// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__2sOuA","line":"Title_line__9ZtAy","label":"Title_label__1TV3L"};